import React, { Component } from "react";
import ReactDOM from "react-dom";
import { getErrorTracking } from "@wss/error-tracking";
import { getDynamicData } from "~/common/Store/actions/updateUserAndChatFromOrigin";
import Modal from "../Modal";

export class GdprBannerModal extends Component {
  constructor(props: { [key: string]: unknown }) {
    super(props);
    import("storage-factory").then(({ storageFactory }) => {
      const storage = storageFactory(() => window.localStorage);

      if (!storage.getItem("data-policy-seen")) {
        this.isInEuropeanUnion();
      }
    });
  }

  // eslint-disable-next-line react/state-in-constructor
  state = { modalOpen: false };

  handleModalClose = () => {
    import("storage-factory").then(({ storageFactory }) => {
      const storage = storageFactory(() => window.localStorage);

      storage.setItem("data-policy-seen", "true");
    });
    this.setState({
      modalOpen: false,
    });
  };

  captureIPCheckError = async (
    error: unknown,
    response: Response | undefined | null,
    responseClone: Response | undefined | null
  ) => {
    getErrorTracking().then(async ({ captureException }) => {
      if (!response) {
        captureException(error);
        return;
      }

      const headerEntries = response?.headers
        ? Object.fromEntries(response.headers.entries())
        : {};

      captureException(error, {
        extra: {
          response: {
            headers: headerEntries,
            ok: response.ok,
            redirected: response.redirected,
            status: response.status,
            statusText: response.statusText,
            type: response.type,
            url: response.url,
            text: responseClone ? await responseClone.text() : "",
          },
        },
      });
    });
  };

  async isInEuropeanUnion() {
    const result = await getDynamicData;
    if (result.isError) return;
    let results;
    let response: Response | undefined;
    let responseClone: Response | undefined;
    try {
      response = await fetch("/object/ip.cfc?method=isEuropeanUnion");
      responseClone = response.clone();
      results = await response.json<{ returnFlag: boolean }>();
    } catch (error) {
      this.captureIPCheckError(error, response, responseClone);
      if (!results) return;
    }

    const backdrop = document.getElementById(
      "productAccessoriesAndOptionsFormBackdrop"
    );
    if (backdrop) {
      backdrop.remove();
    }

    if (results.returnFlag) {
      import("./style.css");
      import(
        /* webpackChunkName: "modals-standalone" */ "~/bootstrap/less/modals-standalone.less"
      );
      this.render();
      this.setState({ modalOpen: true });
    } else {
      const { storageFactory } = await import("storage-factory");

      const storage = storageFactory(() => window.localStorage);
      storage.setItem("outsideOfEuropeanUnion", "true");
    }
  }

  render() {
    const { modalOpen } = this.state;

    return (
      <Modal
        title="User Data Policy"
        className="modal--sm gdprModal"
        isOpen={Boolean(modalOpen)}
        onClose={() => {
          this.setState({ modalOpen: false });
        }}
        modalBodyClassName="gdprBody"
        customFooter={
          <button
            type="button"
            className={
              window.location.pathname.indexOf("blog") === -1
                ? "btn btn-primary"
                : "btn btn-success"
            }
            onClick={this.handleModalClose}
          >
            Accept
          </button>
        }
      >
        <div className="modal__text">
          We would like to use cookies and identify general user data to give
          you a better experience on our website.Using cookies and identifying
          data such as IP address and the type and version of your browser help
          us improve our website&apos;s navigation and provide more personalized
          services to you. To find out more, see our Privacy Policy
        </div>
      </Modal>
    );
  }
}

export default function GdprBanner(): JSX.Element {
  const gdprBannerMount = document.getElementById("gdprBannerMount");
  return <>{ReactDOM.render(<GdprBannerModal />, gdprBannerMount)}</>;
}
